import { render, staticRenderFns } from "./HOPTDb.vue?vue&type=template&id=42aaa217&scoped=true"
import script from "./HOPTDb.vue?vue&type=script&lang=js"
export * from "./HOPTDb.vue?vue&type=script&lang=js"
import style0 from "./HOPTDb.vue?vue&type=style&index=0&id=42aaa217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-load_4e3969014a7d8e6dd81c256359e01f18/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aaa217",
  null
  
)

export default component.exports